import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "../data/content";
import { useLang } from "../i18n";

const StickyCTA = () => {
    const { t } = useLang();
    return (
        <motion.a
            data-testid="sticky-whatsapp-button"
            href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(t.contact.whatsappMsg)}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.4, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="fixed bottom-4 right-4 z-40 flex items-center gap-2 rounded-full bg-olive px-5 py-3.5 text-sm font-bold text-cream shadow-xl shadow-olive/30 transition-[background-color,transform] duration-200 hover:bg-olive-dark active:scale-95 md:hidden"
        >
            <MessageCircle size={18} />
            WhatsApp
        </motion.a>
    );
};

export default StickyCTA;
